import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Check from "@mui/icons-material/Check";

const Stepper = ({ steps, onFinish, onCancel, initialValues }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [formData, setFormData] = useState(initialValues || {});
    const { isLogin } = useSelector((state) => state?.login);

    const next = () => {
        if (currentStep < steps.length - 1) setCurrentStep((prev) => prev + 1);
    };
    const prev = () => {
        if (currentStep > 0) setCurrentStep((prev) => prev - 1);
    };
    const goTo = (index) => setCurrentStep(index);

    const canProceed = steps[currentStep].canProceed
        ? steps[currentStep].canProceed(formData)
        : true;

    const handleFinish = () => {
        if (onFinish) {
            onFinish(formData);
        }
    };
    const handleUpdate = () => {
        if (onFinish) {
            onFinish(formData);
        }
    };

    return (
        <div className="onboarding-shell">
            <div className="onboarding-layout__main">
                    <div className="onboarding-stepper-wrap">
                        <div className="onboarding-stepper__row" role="list">
                    {steps.map((step, idx) => {
                        const isComplete = idx < currentStep;
                        const isCurrent = idx === currentStep;
                        const IconComponent = step.icon;
                        const lineActive = idx < currentStep;

                        return (
                            <React.Fragment key={idx}>
                                <div className="onboarding-step-segment" role="listitem">
                                    <button
                                        type="button"
                                        className={`onboarding-step-node${isCurrent ? " onboarding-step-node--current" : ""}${isComplete ? " onboarding-step-node--complete" : ""}${!isCurrent && !isComplete ? " onboarding-step-node--upcoming" : ""}`}
                                        onClick={() => (idx <= currentStep ? goTo(idx) : undefined)}
                                        disabled={idx > currentStep}
                                        aria-current={isCurrent ? "step" : undefined}
                                        aria-label={`${step.title}${isComplete ? ", completed" : isCurrent ? ", current" : ""}`}
                                    >
                                        <span className="onboarding-step-node__inner">
                                            {isComplete ? (
                                                <Check className="onboarding-step-check" fontSize="small" />
                                            ) : IconComponent ? (
                                                <IconComponent className="onboarding-step-icon" fontSize="small" />
                                            ) : (
                                                <span className="onboarding-step-fallback">{idx + 1}</span>
                                            )}
                                        </span>
                                    </button>
                                    <span
                                        className={`onboarding-step-label${isCurrent ? " onboarding-step-label--current" : ""}`}
                                    >
                                        {step.title}
                                    </span>
                                </div>
                                {idx < steps.length - 1 && (
                                    <div
                                        className={`onboarding-step-connector${lineActive ? " onboarding-step-connector--active" : ""}`}
                                        aria-hidden
                                    />
                                )}
                            </React.Fragment>
                        );
                    })}
                        </div>
                    </div>

                    <div className="onboarding-card">
                        <div className="onboarding-step-panel" key={currentStep}>
                            {steps[currentStep].content({ formData, setFormData })}
                        </div>

                        <div className="onboarding-actions">
                            {!isLogin && (
                                <Link to="/login" className="onboarding-back-link">
                                    ← Back to login
                                </Link>
                            )}
                            <div className="onboarding-actions__buttons">
                                {onCancel && (
                                    <button type="button" className="onboarding-btn onboarding-btn--ghost" onClick={onCancel}>
                                        Cancel
                                    </button>
                                )}
                                {currentStep > 0 && (
                                    <button type="button" className="onboarding-btn onboarding-btn--secondary" onClick={prev}>
                                        Previous
                                    </button>
                                )}
                                {currentStep < steps.length - 1 ? (
                                    <button
                                        type="button"
                                        className="onboarding-btn onboarding-btn--primary"
                                        onClick={next}
                                        disabled={!canProceed}
                                    >
                                        Next
                                    </button>
                                ) : initialValues ? (
                                    <button
                                        type="button"
                                        className="onboarding-btn onboarding-btn--primary"
                                        onClick={handleUpdate}
                                        disabled={!canProceed}
                                    >
                                        Update
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className="onboarding-btn onboarding-btn--primary"
                                        onClick={handleFinish}
                                        disabled={!canProceed}
                                    >
                                        Finish
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    );
};

export default Stepper;
